import React from 'react';
import styled from 'styled-components';
import {useAllProjectsTelStatusCallReportQuery} from 'api';
import useSearchParams from '../../useSearchParams';

export default () => {
  const {searchParams} = useSearchParams();
  const {
    data: {
      allProjectsTelStatusCallReport: {
        call = {},
        reception = {},
        contact = {},
        appoint = {},
        document = {},
        other = {},
        callNg = {},
        receptionNg = {},
        contactNg = {},
      } = {},
      allProjectsTelStatusCallReport = {},
    } = {},
  } = useAllProjectsTelStatusCallReportQuery({
    variables: {
      search: searchParams,
    },
  });

  const totalCount = (object: any): any =>
    Object.values(object).reduce(
      (total: number, value: number) => total + value,
      0,
    );

  const callCount = React.useMemo(() => {
    let count = 0;

    count += totalCount(call);
    count += totalCount(reception);
    count += totalCount(contact);
    count += totalCount(appoint);
    count += totalCount(document);
    count += totalCount(other);
    count += totalCount(callNg);
    count += totalCount(receptionNg);
    count += totalCount(contactNg);

    return count;
  }, [allProjectsTelStatusCallReport]);

  const contactCount = React.useMemo(() => {
    let count = 0;

    count += totalCount(contact);
    count += totalCount(appoint);
    count += totalCount(document);
    count += totalCount(contactNg);

    return count;
  }, [allProjectsTelStatusCallReport]);

  const conversionRate = (before: number, after: number) => {
    if (!before || !after) return 0;

    return Math.round((after / before) * 1000) / 10;
  };

  return (
    <Container>
      <h2>転換率</h2>

      <Table>
        <div className="column far-left">
          <div className="category">
            <span>キーマン接触</span>
          </div>
          <div className="category">
            <span>資料送付</span>
          </div>
          <div className="category">
            <span>アポ獲得</span>
          </div>
        </div>

        <div className="column">
          <div>
            {!!callCount && (
              <span>{conversionRate(callCount, contactCount)}%</span>
            )}
          </div>
          <div>
            {!!callCount && (
              <span>{conversionRate(contactCount, totalCount(document))}%</span>
            )}
          </div>
          <div>
            {!!callCount && (
              <span>{conversionRate(contactCount, totalCount(appoint))}%</span>
            )}
          </div>
        </div>
      </Table>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  > h2 {
    font-weight: bold;
    font-size: 20px;
    line-height: 29px;
    color: var(--text-color-1);
  }
`;

const Table = styled.div`
  display: flex;
  border: 1px solid #e1e6eb;
  border-top: none;
  overflow: scroll;
  width: 430px;

  .column {
    display: flex;
    flex-direction: column;
    flex: 1;

    > div {
      width: 100%;
      min-height: 43px;
      border-top: 1px solid #e1e6eb;
      border-right: 1px solid #e1e6eb;

      display: flex;
      align-items: center;

      &:first-child {
      }

      &:nth-child(2) {
      }

      > span {
        margin: 0 9px 0 auto;
        color: var(--text-color-2);
      }

      &.category {
        > span {
          color: var(--text-color-1);
          font-weight: bold;
        }
      }
    }

    &:last-child {
      > div {
        border-right: none;
      }
    }

    &.far-left {
      left: 0;
      z-index: 10;
      position: sticky;
      background: #ffffff;

      > div {
        width: 272px;
        display: flex;
        align-items: center;
        padding: 0 40px;

        background: #fff;

        &.category {
          padding: 0 13px;

          svg {
            margin-right: 5px;
          }
          span {
            font-weight: bold;
          }
        }

        > span {
          margin: 0;
          font-size: 13px;
        }
      }
    }
  }
`;
